import { createLazyFileRoute } from "@tanstack/react-router";

import { trpc } from "@blis/trpc/react";

import { MaterialsTable } from "@/features/admin/components/materials/MaterialsTable";
import { Section } from "@/features/admin/components/Section";

export const Route = createLazyFileRoute("/_auth/admin/materials/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { data } = trpc.admin.materialSpec.list.useQuery();
  return (
    <>
      <Section.Title>Materials</Section.Title>
      <MaterialsTable materials={data} />
    </>
  );
}
